import http from "@/service/http";

/**
 * 获取优惠券
 * @param {*} data
 * @returns
 */
export const getCode = (data) => {
  return http.put("/member/update_email_and_assign_voucher", data);
};

/**
 * 邮件订阅
 * @param {*} data
 * @returns
 */
export const subscription = (data) => {
  return http.post("/public/newsletters", data);
};
